export default "__VITE_ASSET__Sr6lRPbY__"